import { IMaskInput } from 'react-imask'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import axios from 'axios'
import {modalNames} from "../common/modal/constants/names";
import cn from 'classnames'
import {closeWindow, openWindow} from '../../models/window/actions'

import { ReactComponent as CloseIcon } from './assets/images/close.svg'
import { ReactComponent as PhoneIcon } from './assets/images/phone.svg'
import { ReactComponent as PencilIcon } from './assets/images/pencil.svg'

import c from './assets/sass/contactModal.module.scss'

const ContactModal = () => {
    const dispatch = useDispatch()
    const [phone, setPhone] = useState('')
    const [loading, setLoading] = useState(false)
    const isDisabled = loading || phone.replace(/\D/g, '').length !== 11

    const closeHandler = () => {
        dispatch(closeWindow())
    }

    const recallHandler = async () => {
        if (!phone || loading) {
            return
        }

        try {
            setLoading(true)

            await axios.post('https://dl-massage.ru/api/recall', {
                phone,
            })

            dispatch(closeWindow())
            dispatch(openWindow(modalNames.SENT_MODAL))
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false)
        }
    }

    return (
        <div className={c.component}>
            <div className={c.row}>
                <button className={c.close} onClick={closeHandler}>
                    <CloseIcon className={c.closeIcon}/>
                </button>

                <div className={c.title}>Записаться</div>

                <div className={c.subtitle}>Звоните</div>

                <a href="tel:+79856656294" className={c.phone}>
                    +7 985 665-62-94
                </a>

                <div className={c.subtitle}>Или</div>

                <div className={c.form}>
                    <div className={c.field}>
                        <PhoneIcon className={c.fieldIcon}/>

                        <IMaskInput
                            mask="+{7} 000 000-00-00"
                            value={phone}
                            onAccept={(value) => setPhone(value)}
                            className={c.input}
                            placeholder="+7 --- --- -- --"
                        />

                        <div className={c.fieldTitle}>Ваш номер</div>
                    </div>
                    <button
                        className={cn(c.recall, {
                            [c.disabled]: isDisabled,
                        })}
                        onClick={recallHandler}
                        disabled={isDisabled}
                    >
                        {loading ? 'Отправляем...' : 'Заказать звонок'}
                    </button>
                </div>

                <div className={c.subtitle}>Или</div>

                <a
                    className={c.online}
                    href="https://n1798857.yclients.com/company/1597632/personal/select-services?o="
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Записаться онлайн
                    <PencilIcon className={c.onlineIcon}/>
                </a>
            </div>
        </div>
    )
}

export default ContactModal
